"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.decotrate = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var decotrate = function decotrate(_ref, plugins) {
  var DecoratorComponent = _ref.DecoratorComponent,
      DecoratorFormComponent = _ref.DecoratorFormComponent;
  return plugins.map(function (plugin) {
    if (plugin.legacy || false) {
      return plugin;
    }

    var Component = plugin.Component;
    var hasChildren = plugin.Component().props.hasOwnProperty('children');

    if (!hasChildren) {
      // Prevents the plugin being nested in the decorator multiple times
      plugin.Component = function (props) {
        return /*#__PURE__*/_react["default"].createElement(DecoratorComponent, props, /*#__PURE__*/_react["default"].createElement(Component, props));
      };
    } // plugin.decorated = true;


    plugin.DecoratedForm = DecoratorFormComponent;
    return plugin;
  });
};

exports.decotrate = decotrate;

var _default = function _default(settings, plugins) {
  var _plugins$content = plugins.content,
      content = _plugins$content === void 0 ? [] : _plugins$content,
      _plugins$layout = plugins.layout,
      layout = _plugins$layout === void 0 ? [] : _plugins$layout;
  plugins.content = decotrate(settings, content);
  plugins.layout = decotrate(settings, layout);
  return plugins;
};

exports["default"] = _default;